import qs from 'query-string';

import { IMAGE_SERVER_BASE_URL } from 'config/constants';

import { ImageContentType, ImageType, NagraImageUrlParams } from './types';

export function getImageUrl({
    contentId,
    width,
    height,
    aspect,
    imageType = ImageType.ANY,
    contentType = ImageContentType.ANY,
}: NagraImageUrlParams) {
    return qs.stringifyUrl(
        {
            url: `${IMAGE_SERVER_BASE_URL}/${contentType}/${contentId}/${imageType}`,
            query: {
                width,
                height,
                aspect,
                imageFormat: 'webp',
            },
        },
        { skipNull: true },
    );
}
